import { createRoot } from 'react-dom/client';
import { initSentry, Sentry } from '@/lib/sentry';
import App from './App';
import './index.css';
import '@/lib/admin-fetch-patch';

// Initialise Sentry before anything renders so errors during startup are captured
initSentry();

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
        <h2>Something went wrong</h2>
        <p>Please refresh the page. If the problem persists, contact support.</p>
        <button onClick={() => window.location.reload()}>Refresh</button>
      </div>
    }
  >
    <App />
  </Sentry.ErrorBoundary>,
);
